// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21 10V22H19V12L5 12L5 22H3L3 10L21 10ZM21 2V8L3 8L3 2L21 2Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-page-head-filled')
export default class PageHeadFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'page-head-filled',
    }
  }
}
